export default {
  'shadow-base': '0px 1px 3px rgba(0, 0, 0, 0.2)',
  'shadow-lg': '0px 2px 4px rgba(0, 0, 0, 0.15), 0px 2px 8px rgba(0, 0, 0, 0.05)',
  'shadow-xl': '0px 2px 4px rgba(0, 0, 0, 0.2), 0px 8px 16px rgba(0, 0, 0, 0.1)',
};
